import type { CachedWorkbook, LocalCache } from '../app/ports.js';

const DB = 'personal-finances', VERSION = 2;
export const WORKBOOKS = 'workbooks', COMMANDS = 'commands';

export function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(WORKBOOKS)) db.createObjectStore(WORKBOOKS, { keyPath: 'sourceId' });
      if (!db.objectStoreNames.contains(COMMANDS)) db.createObjectStore(COMMANDS, { keyPath: 'key', autoIncrement: true });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export function tx<T>(store: string, mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return openDb().then(db => new Promise<T>((resolve, reject) => {
    const req = fn(db.transaction(store, mode).objectStore(store));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }));
}

/** Copia local en IndexedDB. Si el navegador no la permite (modo privado), funciona sin copia. */
export const indexedDbCache: LocalCache = {
  async load(sourceId) { try { return (await tx<CachedWorkbook | undefined>(WORKBOOKS, 'readonly', s => s.get(sourceId))) ?? null; } catch { return null; } },
  async save(value) { try { await tx(WORKBOOKS, 'readwrite', s => s.put(value)); } catch { /* sin copia local */ } },
  async clear() { try { await tx(WORKBOOKS, 'readwrite', s => s.clear()); await tx(COMMANDS, 'readwrite', s => s.clear()); } catch { /* nada que borrar */ } },
};
